import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { DigitalSignageDataProvider } from "providers/DigitalSignageDataProvider";
import WebSocketProvider from "@bit/arey.instore-utils-react.websocket";

ReactDOM.render(
  <React.StrictMode>
    <DigitalSignageDataProvider>
      <WebSocketProvider url={(window as any)?.config?.digitalWebSocketUrl}>
        <App />
      </WebSocketProvider>
    </DigitalSignageDataProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
